import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const pinStyle = StyleSheet.create({
    outerContainer: {
        flex: 1,
        backgroundColor: appColors?.light,
    },
    fieldOuterContainer: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center"
    },
    fieldInnerContainer: {
        marginVertical: 20,
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center"
    },
    pinFieldValue: {
        width: 50,
        height: 50,
        margin: 20
    },
    animatedCursor: {
        position: "absolute",
        width: '100%',
        backgroundColor: appColors?.primary,
        bottom: 0
    },
    securityView: {
        top: -10,
        marginStart: 10
    },
    buttonStyle: {
        paddingHorizontal: 30,
        backgroundColor: appColors?.primary,
        borderRadius: 10
    },
    titleStyle: {
        fontFamily: appFonts?.bold,
        color: appColors?.light,
        fontSize: fontSize?.mediumFontSize
    },
    keyboardOuterView: {
        justifyContent: "center",
        alignItems: "center"
    },
    keyboardInnerView: {
        flex: 1,
        flexDirection: "row",
        justifyContent: "center",
        alignContent: "center",
        flexWrap: "wrap"
    },
    numberButton: {
        marginHorizontal: 30,
        marginVertical: 10,
        width: 150,
        height: 100,
        borderRadius: 10,
        justifyContent: "center",
        alignItems: "center"
    },
    keypadContainer: {
        paddingHorizontal: 20,
        paddingVertical: 10,
        width: '100%',
        maxWidth: "100%",
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1
    },
    keypadButton: {
        aspectRatio: 1,
        padding: 12,
        margin: 15,
    },
    buttonTouchable: {
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 50,
        elevation: 2,
        backgroundColor: appColors?.lightBackgroundColor,
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.2,
        shadowRadius: 2,
    },
    buttonText: {
        color: appColors?.lightDark,
        fontFamily: appFonts?.bold
    }
})